export { default as deDE } from './lib/de-DE.json';
export { default as enGB } from './lib/en-GB.json';
export { default as enUS } from './lib/en-US.json';
export { default as esES } from './lib/es-ES.json';
export { default as frFR } from './lib/fr-FR.json';
export { default as itIT } from './lib/it-IT.json';
export { default as plPL } from './lib/pl-PL.json';
export { default as ptPT } from './lib/pt-PT.json';
export { default as enAU } from './lib/en-AU.json';
export { default as nlNL } from './lib/nl-NL.json';
